import * as React from "react"
import {AxiosResponse} from "axios";

import {
    getRemovedWatermarkImageBlob,
    godProjectId,
    projectId,
    isGodModeOn,
    saveWatermarkObjects,
} from "app/helpers/api";

import {SetByUser} from "./product-table"

import WatermarkMarkerCommon, { ObjectsType } from "./watermark-marker-common";
import {echo} from "app/components/websocketeer";
import { ID } from "app/types/app-types";

interface Props {
    updateWatermarkMasks: Function
    closeModal: Function
    changeSetByUser: Function
    setByUser: SetByUser
    idx: number
    altLevel: number
    isAlt: boolean
    productId: ID
    imageOrAltImageId: ID
    imageOrAltImageHash: string
    imageOrAltImageObjects?: string
    imageOrAltImageUrl: string
    imageOrAltImageUrlHash: string
    imageOrAltImageWidth: number
    imageOrAltImageHeight: number
    imageOrAltImageMaskHash?: string
    showClose: boolean
}

interface State {
    isSaving: boolean
    isWaitingForResult: boolean
    imageBlob: string
}

type WebSocketMessage = {
    is_alt: boolean
    image_or_alt_image_id: number
    image_or_alt_image_hash?: string
    product_id: number
    project_id: number
    status: string
    base64_image_src: string
}

class WatermarksMarker extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props)

        this.state = {
            isSaving: false,
            isWaitingForResult: false,
            imageBlob: null,
        }

        const actualProjectId = isGodModeOn ? godProjectId : projectId

        echo.channel(`private-project.${actualProjectId}`)
            .listen('.watermark.started', (event) => this.handleProcessStarted(event))

        echo.channel(`private-project.${actualProjectId}`)
            .listen('.watermark.removed', (event) => this.handleProcessDone(event))
    }

    handleProcessStarted = (message : WebSocketMessage) => {
        const { productId, imageOrAltImageId } = this.props
        if (message.product_id === productId && message.image_or_alt_image_id === imageOrAltImageId) {
            console.debug('handle inpainting process started', message)
        }
    }

    handleProcessDone = (message : WebSocketMessage) => {
        const { productId, imageOrAltImageId, imageOrAltImageHash } = this.props
        if (message.image_or_alt_image_id === imageOrAltImageId || (message.image_or_alt_image_hash && message.image_or_alt_image_hash === imageOrAltImageHash)) {
            console.debug(`handle inpainting process done for product ${message.product_id} image ${message.image_or_alt_image_id} status ${message.status}, image ${imageOrAltImageId} product ${productId}`)
            this.setState({imageBlob: message.base64_image_src, isWaitingForResult: false})
            this.refreshResultImage()
        }
    }

    refreshResultImage = () => {
        const { productId, imageOrAltImageId, altLevel } = this.props

        const isAlt = typeof altLevel !== 'undefined' && altLevel !== null

        console.debug(`start refreshing product ${productId} image ${imageOrAltImageId} level ${altLevel}`)


        getRemovedWatermarkImageBlob(productId, imageOrAltImageId, isAlt ? altLevel : null)
            .then((response: AxiosResponse<any>) => {
                console.debug('ok response from refresh image', response.data)
                this.setState({imageBlob: response.data.imageBlob, isWaitingForResult: false})
            })
            .catch(error => {
                console.debug('bad response from refresh image', error.response)
            })
    }

    componentDidMount() {
        if (this.props.imageOrAltImageObjects) {
            this.refreshResultImage()
        }
    }

    saveWatermarkObjects = (isAlt: boolean, imageOrAltImageId: number, altLevel: number, productId: number, objects: ObjectsType, png: string, imageOrAltImageWidth: number, imageOrAltImageHeight: number, isCloseOnSave: boolean) => {
        if (this.state.isSaving) {
            return;
        }

        this.setState({ isSaving: true, isWaitingForResult: true })
        saveWatermarkObjects(isAlt, imageOrAltImageId, altLevel, productId, objects, png, imageOrAltImageWidth, imageOrAltImageHeight)
            .then((response: AxiosResponse<any>) => {
                if (!isAlt) {
                    this.props.changeSetByUser(imageOrAltImageId, this.props.idx, (objects && Array.isArray(objects) && objects.length > 0) ? 1 : 0)
                }
                this.props.updateWatermarkMasks(objects)
            })
            .catch(e => {
                console.error('error', e)
            })
            .finally(() => {
                this.setState({isSaving: false})
                if (!objects || objects.length === 0) {
                    this.setState({isWaitingForResult: false, imageBlob: null})
                }
                if (isCloseOnSave) {
                    this.props.closeModal()
                }
            })
    }

    clearImageBlob = () => {
        this.setState({
            imageBlob: null,
            isWaitingForResult: false,
        })
    }

    render() {
        return (
            <WatermarkMarkerCommon
                markerType={'wmremove-manual'}
                saveObjects={this.saveWatermarkObjects}
                clearImageBlob={this.clearImageBlob}
                closeModal={this.props.closeModal}
                is_alt={this.props.isAlt}
                altLevel={this.props.altLevel}
                image_id={this.props.imageOrAltImageId}
                product_id={this.props.productId}
                image_url={this.props.imageOrAltImageUrl}
                image_url_hash={this.props.imageOrAltImageUrlHash}
                image_width={this.props.imageOrAltImageWidth}
                image_height={this.props.imageOrAltImageHeight}
                user_set_objects={this.props.imageOrAltImageObjects}
                mask_hash={this.props.imageOrAltImageMaskHash}
                imageBlob={this.state.imageBlob}
                isWaitingForResult={this.state.isWaitingForResult}
                showClose={this.props.showClose}
            />
        )
    }
}

export default WatermarksMarker
